import sysConfig from '@/config';
import router from '@/router';
import tool from '@/utils/tool';
import axios from 'axios';
import { ElMessageBox, ElNotification } from 'element-plus';

axios.defaults.baseURL = '';

axios.defaults.timeout = sysConfig.TIMEOUT;

// HTTP request 拦截器
axios.interceptors.request.use(
  (config) => {
    let signJson;
    if (!sysConfig.REQUEST_CACHE && config.method == 'get') {
      config.params = config.params || {};
      config.params['_'] = new Date().getTime();
    }
    if (config.method == 'get') {
      signJson = Object.assign({}, config.params);
    } else {
      signJson = Object.assign({}, config.data);
    }
    let token = tool.cookie.get(sysConfig.TOKEN_COOKIE_KEY);
    if (token) {
      config.headers[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token;
      signJson[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token;
    }
    let userInfo = tool.data.get('USER_INFO');
    if (userInfo && userInfo.filialeId) {
      signJson.filialeId = userInfo.filialeId;
    }
    if (process.env.NODE_ENV === 'development') {
      config.headers['ip'] = '127.0.0.1'
    }
    Object.assign(config.headers, sysConfig.HEADERS);

    const nowTime = new Date().getTime();
    const noneStr = tool.randomString(20);
    const from = sysConfig.FROM;

    config.headers['timestamp'] = nowTime;
    config.headers['nonestr'] = noneStr;
    config.headers['from'] = from;

    // 为mock设置的
    config.headers['apifoxToken'] = "d4JwNYbON1dKXfwNGCOeN"
    signJson.timestamp = nowTime;
    signJson.nonestr = noneStr;
    signJson.from = from;

    config.headers['sign'] = tool.sign(signJson);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//FIX 多个API同时401时疯狂弹窗BUG
let MessageBox_401_show = false

// HTTP response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      // 下载返回
      return response;
    } else {
      const res = response.data;
      if (res.code === 0) {
        return res;
      } else {
        ElNotification.warning({
          title: '请求错误！',
          dangerouslyUseHTMLString: true,
          message: res.message || 'error'
        });
        return Promise.reject(res);
      }
    }
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (!MessageBox_401_show) {
            MessageBox_401_show = true
            ElMessageBox.confirm(
              '当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。',
              '无权限访问',
              {
                type: 'error',
                closeOnClickModal: false,
                center: true,
                confirmButtonText: '重新登录',
                beforeClose: (action, instance, done) => {
                  MessageBox_401_show = false
                  done()
                }
              }
            ).then(() => {
              // router.replace({ path: '/login' });
              router.push({ path: '/login?redirect=' + router.currentRoute.value.fullPath });
            }).catch(() => { });
          }
          break;
        case 403:
          ElNotification.error({
            title: '拒绝访问',
            message: error.response.data.msg || 'Status:500，服务器拒绝访问！',
          });
          break;
        case 404:
          ElNotification.error({
            title: '请求错误',
            message: 'Status:404，正在请求不存在的服务器记录！',
          });
          break;
        case 405:
          ElNotification.error({
            title: '请求错误',
            message: error.response.data.msg || 'Status:405，服务器发生错误！',
          });
          break;
        case 408:
          ElNotification.error({
            title: '请求超时',
            message: error.response.data.msg || 'Status:408，服务器请求超时！',
          });
          break;
        case 500:
          ElNotification.error({
            title: '请求错误',
            message: error.response.data.msg || 'Status:500，服务器发生错误！',
          });
          break;
        case 902:
          ElNotification.error({
            title: '服务器错误',
            message: error.response.data.msg || 'Status:902，服务器发生错误！',
          });
          break;
        default:
          ElNotification.error({
            title: '请求错误',
            message: error.message || `Status:${error.response.status}，未知错误！`,
          });
          break;
      }
    } else {
      ElNotification.error({
        title: '请求错误',
        message: '请求服务器无响应！',
      });
    }

    return Promise.reject(error.response);
  }
);

var http = {
  /** get 请求
   * @param  {接口地址} url
   * @param  {请求参数} params
   * @param  {参数} config
   */
  get: function (url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params: params,
        ...config,
      })
        .then((response) => {
          resolve(config.codeFlag ? response : response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /** post 请求
   * @param  {接口地址} url
   * @param  {请求参数} data
   * @param  {参数} config
   */
  post: function (url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: data,
        ...config,
      })
        .then((response) => {
          resolve(config.codeFlag ? response : response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /** put 请求
   * @param  {接口地址} url
   * @param  {请求参数} data
   * @param  {参数} config
   */
  put: function (url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data: data,
        ...config,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /** patch 请求
   * @param  {接口地址} url
   * @param  {请求参数} data
   * @param  {参数} config
   */
  patch: function (url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: url,
        data: data,
        ...config,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /** delete 请求
   * @param  {接口地址} url
   * @param  {请求参数} data
   * @param  {参数} config
   */
  delete: function (url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: url,
        data: data,
        ...config,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /** jsonp 请求
   * @param  {接口地址} url
   * @param  {JSONP回调函数名称} name
   */
  jsonp: function (url, name = 'jsonp') {
    return new Promise((resolve) => {
      var script = document.createElement('script');
      var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`;
      script.id = _id;
      script.type = 'text/javascript';
      script.src = url;
      window[name] = (response) => {
        resolve(response);
        document.getElementsByTagName('head')[0].removeChild(script);
        try {
          delete window[name];
        } catch (e) {
          window[name] = undefined;
        }
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  },
};

export default http;
